export default __webpack_public_path__ + "static/media/private-onboarding-gif.284fe67b.gif";